module.exports = __webpack_public_path__ + "static/media/884a2e08-8060-4eb0-a135-619086180e52.0f422aab.png";